import { c as _c } from "react/compiler-runtime";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { ApiRateMatter } from "@/generated/models/ApiRateMatter";
import RepCategorySearch, { RepCategorySearchSize } from "@/components/utils/input/rep-category/RepCategorySearch";
import { CreditDirection } from "../GroupCard";
import GroupCardActionNumberInput from "../utils/GroupCardActionNumberInput";
import type { JSX } from "react";
export default function GroupCardVoteAllInputs(t0) {
  const $ = _c(21);
  const {
    matter,
    group,
    amountToAdd,
    category,
    creditDirection,
    setCategory,
    setAmountToAdd,
    setCreditDirection
  } = t0;
  const t1 = `${group.id}_nic`;
  let t2;
  if ($[0] !== amountToAdd || $[1] !== creditDirection || $[2] !== setAmountToAdd || $[3] !== setCreditDirection || $[4] !== t1) {
    t2 = <div className="tw-w-full xl:tw-max-w-[17.156rem]"><GroupCardActionNumberInput label="NIC" componentId={t1} amount={amountToAdd} creditDirection={creditDirection} setCreditDirection={setCreditDirection} setAmount={setAmountToAdd} /></div>;
    $[0] = amountToAdd;
    $[1] = creditDirection;
    $[2] = setAmountToAdd;
    $[3] = setCreditDirection;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `${group.id}_rep`;
  let t4;
  if ($[6] !== amountToAdd || $[7] !== creditDirection || $[8] !== setAmountToAdd || $[9] !== setCreditDirection || $[10] !== t3) {
    t4 = <div className="tw-w-full md:tw-w-[58%]"><GroupCardActionNumberInput label="Rep" componentId={t3} amount={amountToAdd} creditDirection={creditDirection} setCreditDirection={setCreditDirection} setAmount={setAmountToAdd} /></div>;
    $[6] = amountToAdd;
    $[7] = creditDirection;
    $[8] = setAmountToAdd;
    $[9] = setCreditDirection;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== category || $[13] !== setCategory) {
    t5 = <div className="tw-w-full md:tw-w-[42%]"><RepCategorySearch category={category} setCategory={setCategory} size={RepCategorySearchSize.SM} /></div>;
    $[12] = category;
    $[13] = setCategory;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className="tw-w-full tw-flex tw-flex-wrap sm:tw-flex-nowrap tw-gap-x-4 tw-gap-y-4">{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t2 || $[19] !== t6) {
    t7 = {
      [ApiRateMatter.Cic]: t2,
      [ApiRateMatter.Rep]: t6
    };
    $[18] = t2;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const components = t7;
  return components[matter];
}